import React from 'react'

const ShapesSection = ({
    title,
    loading,
    error,
    items = [],
    renderItem,
    emptyComponent,
    skeletonCount = 9,
    pagination,
}) => {
    return (
        <div className="SidebarPanel__Section">
            <h3 className="SidebarPanel__SectionTitle">{title}</h3>

            {error && (
                <p className="SidebarPanel__Error" role="alert">
                    {error.message || error}
                </p>
            )}

            {loading && (
                <div className="SidebarPanel__ShapesGrid">
                    {Array.from({length: skeletonCount}).map((_, i) => (
                        <div
                            key={`skeleton-${i}`}
                            className="SidebarPanel__ShapeThumb SidebarPanel__ShapeThumb--skeleton"
                        />
                    ))}
                </div>
            )}

            {!loading && !error && (
                <>
                    {items.length === 0 && emptyComponent ? (
                        emptyComponent
                    ) : (
                        <div className="SidebarPanel__ShapesGrid">
                            {items.map(renderItem)}
                        </div>
                    )}

                    {pagination && pagination.totalPages > 1 && (
                        <div className="SidebarPanel__Pagination">
                            <button
                                type="button"
                                className="SidebarPanel__PaginationBtn"
                                disabled={!pagination.canPrev}
                                onClick={pagination.goPrev}
                                aria-label={`Previous ${title.toLowerCase()} page`}
                            >
                                Prev
                            </button>
                            <span className="SidebarPanel__PaginationLabel">
                                {pagination.page} / {pagination.totalPages}
                            </span>
                            <button
                                type="button"
                                className="SidebarPanel__PaginationBtn"
                                disabled={!pagination.canNext}
                                onClick={pagination.goNext}
                                aria-label={`Next ${title.toLowerCase()} page`}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default ShapesSection
